const styles = theme => ({
    modal:{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        backgroundColor: '#ffffff',
        borderRadius:'8px',
        padding: '25px',
    },

    uploadText:{
        color: '#000000 ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '20px ! important',
        textTransform: 'capitalize !important'
    },
    
    uploadGrid:{
        display:'flex !important',
        flexDirection:'column !important',
    },

    uploadBox : {
        height:'120px',
        display:'flex',
        justifyContent:'center',
        alignItems:'center !important',
        flexDirection:'column !important'
    },

    chooseButton : {
        width:'150px !important',
        height:'40px !important',
        backgroundColor:'rgb(244, 71, 72) !important',
        fontFamily: "cardiuma-regular !important",
        padding:'9px 15px 9px 15px !important',
        fontSize:'12px !important',
        marginTop:'25px !important'
    },

    uploadedText:{
        margin:'15px 0px 20px 0px !important',
    },

    filename:{
        color: '#000000 ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '14px ! important'
    },

    errText:{
        color: '#cc0000 ! important',
        fontFamily: 'cardiuma-regular ! important',
        fontSize: '14px ! important'
    },

    button : {
        gap: "2px !important",
        color: "rgb(255, 255, 255) !important",
        backgroundColor: "rgb(244, 71, 72) !important",
        fontFamily: "cardiuma-regular !important",
        fontSize: "12px !important",
        fontStyle: "normal !important",
        BorderRadius: '4px !important',
        padding:'9px 15px 9px 15px !important',
    },

    disabledButton :{ 
            color: "#ffffff !important",
            backgroundColor: "#999999 !important",
            fontFamily: "cardiuma-regular !important",
            fontSize: "12px !important",
            fontStyle: "normal !important",
            BorderRadius: '4px !important',
            padding:'9px 15px 9px 15px !important',

    },
})

export default styles